class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;

    // While the drawer is open (upsell adds, gift wrap, quick view),
    // patch the money-touched regions instead of swapping the whole
    // drawer — keeps open collapsibles, scroll and upsell state intact.
    const drawerOpen = this.drawer && !!this.drawer.querySelector('details[open]');

    this.getSectionsToRender().forEach((section => {
      if (!document.getElementById(section.id)) return;

      if (
        section.id === 'mini-cart' &&
        drawerOpen &&
        window.theme && theme.patchMiniCart &&
        parsedState.sections[section.id] &&
        theme.patchMiniCart(this.getSectionInnerHTML(parsedState.sections[section.id], section.selector))
      ) return;

      document.getElementById(section.id).innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('mini-cart', MiniCart);

class TermsAgreement extends HTMLElement {
  connectedCallback() {
    this.checkbox = this.querySelector('input[type="checkbox"]');
    this.error = this.querySelector('.cart-legal__error');
    this.form = this.closest('form') || document.getElementById('cart');
    this.scope = this.closest('#mini-cart, .cart__footer') || this;
    if (!this.checkbox || !this.hasAttribute('data-required')) return;

    this.onChange = () => this.checkbox.checked && this.toggleError(false);
    this.onSubmit = (event) => {
      if (this.checkbox.checked || (event.submitter?.name && event.submitter.name !== 'checkout')) return;
      event.preventDefault();
      this.toggleError(true);
    };
    this.onClick = (event) => {
      if (this.checkbox.checked || !event.target.closest('.additional-checkout-buttons')) return;
      event.preventDefault();
      event.stopPropagation();
      this.toggleError(true);
    };

    this.checkbox.addEventListener('change', this.onChange);
    this.form?.addEventListener('submit', this.onSubmit);
    this.scope.addEventListener('click', this.onClick, true);
  }

  disconnectedCallback() {
    this.checkbox?.removeEventListener('change', this.onChange);
    this.form?.removeEventListener('submit', this.onSubmit);
    this.scope?.removeEventListener('click', this.onClick, true);
  }

  toggleError(show) {
    this.classList.toggle('is-error', show);
    this.checkbox.toggleAttribute('aria-invalid', show);
    if (this.error) this.error.hidden = !show;
    if (show) this.checkbox.focus({ focusVisible: true });
  }
}

if (!customElements.get('terms-agreement')) {
  customElements.define('terms-agreement', TermsAgreement);
}
